// Export the Component Definition for use in Contentful Studio
export {FullWidthActionBlockContentfulComponentDefinition} from './fullWidthActionBlockContentfulDefinition';
export {default} from './FullWidthActionBlock';
